import { userManager } from "../../components/OidcContext";
import types from "./actionTypes";

class UserActions {
    static setLoggedIn(user) {
        return {
            type: types.USER.SET_LOGGED_IN,
            data: {
                authenticated: true,
                details: user.details && { ...user.details },
                error: user.error
            }
        };
    }

    static logout() {
        return async function () {
            await userManager.signoutRedirect();
        };
    }
}
export default UserActions;
